import YYButton from './button'
import YYButtonGroup from './button-group'

YYButton.YYButtonGroup = YYButtonGroup
export default YYButton